import { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getFlowFilters } from "./flowFilters";

export interface FlowFilterFormForPacksProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
  onValidationChange?: (propertyName: string, isValid: boolean) => void;
}
export const FlowFilterFormForPacks: FC<FlowFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  onValidationChange,
  updateFilter,
}) => {
  return (
    <FilterFormBuilder
      filterOptions={filterOptions}
      filter={filter}
      updateFilter={updateFilter}
      items={getFlowFilters(false, false)}
      onValidationChange={onValidationChange}
    />
  );
};
